// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `challenge-popup simple-select .simple-select .select-box {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - var(--m-tabs-height));
  width: 100%;
  padding: 0px;
}
challenge-popup simple-select .simple-select .motes-card {
  border: 0;
}
challenge-popup simple-select .simple-select .overlay-container {
  height: 100vh;
  width: 100%;
  max-width: var(--max-page-width);
  padding: 0px;
  margin-top: 0;
}
challenge-popup simple-select .simple-select header motes-media {
  border-top: 2px solid var(--motes-white);
}
challenge-popup simple-select .simple-select section {
  position: relative;
  height: 100%;
  padding: 0px 10px;
  overflow-y: auto;
  overflow-x: hidden;
}
challenge-popup simple-select .simple-select .button-container {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 1em 10px 2em 10px;
}
challenge-popup simple-select .simple-select .button-container::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: -5vh;
  height: 5vh;
  width: 100%;
  background: linear-gradient(transparent, var(--motes-white));
  pointer-events: none;
}
challenge-popup simple-select .simple-select hr {
  display: none;
}
challenge-popup h3 {
  padding-left: 10px;
}
challenge-popup h3::after {
  content: "";
  display: block;
  width: 30%;
  padding-top: 0.5rem;
  border-bottom: 2px solid var(--motes-highlight-color);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/challenge-popup/challenge-popup.component.scss"],"names":[],"mappings":"AAEQ;EACI,kBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;AADZ;AAIQ;EACI,SAAA;AAFZ;AAKQ;EACI,aAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;AAHZ;AAOY;EACI,wCAAA;AALhB;AASQ;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAPZ;AAUQ;EACI,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,0BAAA;AARZ;AAYQ;EACI,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,4DAAA;EACA,oBAAA;AAVZ;AAaQ;EACI,aAAA;AAXZ;AAeI;EACI,kBAAA;AAbR;AAeQ;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;EACA,qDAAA;AAbZ","sourcesContent":["challenge-popup {\n    simple-select .simple-select {\n        .select-box {\n            position: absolute;\n            bottom: 0;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            height: calc(100vh - var(--m-tabs-height));\n            width: 100%;\n            padding: 0px;\n        }\n\n        .motes-card {\n            border: 0;\n        }\n\n        .overlay-container {\n            height: 100vh;\n            width: 100%;\n            max-width: var(--max-page-width);\n            padding: 0px;\n            margin-top: 0;\n        }\n\n        header {\n            motes-media {\n                border-top: 2px solid var(--motes-white);\n            }\n        }\n\n        section {\n            position: relative;\n            height: 100%;\n            padding: 0px 10px;\n            overflow-y: auto;\n            overflow-x: hidden;\n        }\n\n        .button-container {\n            position: relative;\n            box-sizing: border-box;\n            width: 100%;\n            padding: 1em 10px 2em 10px;\n        }\n\n        // Text fade effect\n        .button-container::before {\n            content: \"\";\n            box-sizing: border-box;\n            position: absolute;\n            top: -5vh;\n            height: 5vh;\n            width: 100%;\n            background: linear-gradient(transparent, var(--motes-white));\n            pointer-events: none;\n        }\n\n        hr {\n            display: none;\n        }\n    }\n\n    h3 {\n        padding-left: 10px;\n\n        &::after {\n            content: \"\";\n            display: block;\n            width: 30%;\n            padding-top: 0.5rem;\n            border-bottom: 2px solid var(--motes-highlight-color);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
